import { AdminUserDTO } from "@shaarp/common";
import { DataTable } from "../data-table/data-table";
import { dataTableAdminUsersColumns } from "./data-table-admin-users-columns";

export default function DataTableAdminUsers({
  users,
  isLoading,
  toolbarContent,
  onRefresh,
}: {
  users: AdminUserDTO[];
  isLoading: boolean;
  toolbarContent?: React.ReactNode;
  onRefresh: () => void;
}) {
  return (
    <DataTable
      data={users}
      columns={dataTableAdminUsersColumns(onRefresh)}
      columnsPersistenceKey="data-table-admin-users"
      isLoading={isLoading}
      sortingState={[{ id: "Rejoint le", desc: true }]}
      toolbarContent={toolbarContent}
    />
  );
}
